var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLibraryMoreSelect(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 4.5C18.1545 4.5 19.5 5.8455 19.5 7.5V16.5C19.5 18.1545 18.1545 19.5 16.5 19.5H7.5C5.8455 19.5 4.5 18.1545 4.5 16.5V7.5C4.5 5.8455 5.8455 4.5 7.5 4.5H16.5ZM16.5 3H7.5C5.0145 3 3 5.0145 3 7.5V16.5C3 18.9855 5.0145 21 7.5 21H16.5C18.9855 21 21 18.9855 21 16.5V7.5C21 5.0145 18.9855 3 16.5 3Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4677 15.75C10.278 15.75 10.089 15.678 9.94273 15.5355L7.79998 13.4355C7.50448 13.146 7.49998 12.6712 7.78948 12.375C8.07973 12.0787 8.55523 12.075 8.84998 12.3637L10.4677 13.95L15.2992 9.21447C15.5955 8.92497 16.0702 8.92797 16.3597 9.22497C16.65 9.52047 16.6455 9.99597 16.35 10.2855L10.9927 15.5355C10.8465 15.678 10.6575 15.75 10.4677 15.75Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLibraryMoreSelect);
export default __webpack_public_path__ + "static/media/libraryMoreSelect.536c63dfbb5266fcd348cd818943c64d.svg";
export { ForwardRef as ReactComponent };